var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        { staticStyle: { "flex-shrink": "0" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-row",
                { staticStyle: { "flex-shrink": "0" } },
                [
                  _c("w-tabs", {
                    staticClass: "tabs",
                    attrs: { tabs: _vm.tabs },
                    model: {
                      value: _vm.currentTab,
                      callback: function ($$v) {
                        _vm.currentTab = $$v
                      },
                      expression: "currentTab",
                    },
                  }),
                  _c("w-spacer"),
                  _vm.hasFilters
                    ? _c(
                        "w-chip",
                        {
                          attrs: { closable: "" },
                          on: {
                            click: function ($event) {
                              _vm.showFilters = true
                            },
                            close: function ($event) {
                              return _vm.removeFilters()
                            },
                          },
                        },
                        [_vm._v(" Filters actief ")]
                      )
                    : _vm._e(),
                  _c(
                    "w-row",
                    { staticClass: "push-down", attrs: { "no-margin": "" } },
                    [
                      _c(
                        "div",
                        { style: { position: "relative" } },
                        [
                          _vm.isSearching
                            ? _c("w-fa", {
                                staticClass: "cancel-search",
                                attrs: { icon: "times" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onCancelSearch()
                                  },
                                },
                              })
                            : _vm._e(),
                          _c("w-input", {
                            staticClass: "mr",
                            attrs: { icon: "search" },
                            on: {
                              focus: function ($event) {
                                return _vm.onQuickSearch()
                              },
                              keyup: function ($event) {
                                _vm.quickFilters.searchInput == ""
                                  ? _vm.onCancelSearch()
                                  : ""
                              },
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.onQuickSearch()
                              },
                            },
                            model: {
                              value: _vm.quickFilters.searchInput,
                              callback: function ($$v) {
                                _vm.$set(_vm.quickFilters, "searchInput", $$v)
                              },
                              expression: "quickFilters.searchInput",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-button-bar",
                        { staticClass: "mr" },
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Uitgebreid zoeken",
                                  expression: "'Uitgebreid zoeken'",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  _vm.showGlobalSearch = true
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: {
                                  icon: "search-plus",
                                  size: "1x",
                                  fab: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-button-bar",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Ticket bekijken",
                                  expression: "'Ticket bekijken'",
                                },
                              ],
                              attrs: { disabled: _vm.selected.length == 0 },
                              on: {
                                click: function ($event) {
                                  return _vm.openTicket()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "eye" } })],
                            1
                          ),
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Nieuw ticket",
                                  expression: "'Nieuw ticket'",
                                },
                              ],
                              attrs: { to: "/ticket/new" },
                            },
                            [_c("w-fa", { attrs: { icon: "plus" } })],
                            1
                          ),
                          _c(
                            "w-button",
                            {
                              staticClass: "light ml",
                              on: {
                                click: function ($event) {
                                  _vm.showFilters = true
                                },
                              },
                            },
                            [_vm._v(" Filter ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-ticket-data-table", {
        attrs: {
          "is-fetching": _vm.isFetching,
          order: _vm.pagination.order,
          "order-ascending": _vm.pagination.ascending,
          selected: _vm.selected,
          tickets: _vm.tickets,
        },
        on: {
          order: function ($event) {
            return _vm.onOrder($event)
          },
          refresh: function ($event) {
            return _vm.onRefresh()
          },
          "open-ticket": function ($event) {
            return _vm.openTicket($event)
          },
        },
      }),
      _c("app-browse-pagination", {
        attrs: {
          limit: _vm.pagination.limit,
          page: _vm.pagination.offset / _vm.pagination.limit + 1,
          records: _vm.records,
          "show-ticket-filters": true,
          value: _vm.quickFilters,
        },
        on: {
          limit: function ($event) {
            _vm.pagination.limit = $event
          },
          page: function ($event) {
            return _vm.setPage($event)
          },
          toggle: function ($event) {
            ;(_vm.quickFilters.read =
              _vm.quickFilters.read === undefined ? false : undefined),
              _vm.fetch()
          },
        },
      }),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.showFilters,
            callback: function ($$v) {
              _vm.showFilters = $$v
            },
            expression: "showFilters",
          },
        },
        [
          _c("app-ticket-quick-filters", {
            attrs: { value: _vm.quickFilters },
            on: {
              close: function ($event) {
                _vm.showFilters = false
              },
              input: function ($event) {
                return _vm.onQuickFilters($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.showGlobalSearch,
            callback: function ($$v) {
              _vm.showGlobalSearch = $$v
            },
            expression: "showGlobalSearch",
          },
        },
        [
          _vm.showGlobalSearch
            ? _c("app-global-search", {
                on: {
                  close: function ($event) {
                    _vm.showGlobalSearch = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/tickets",
            "full-height": "",
            "escape-close": "",
          },
        },
        [_c("router-view", { key: _vm.$route.path })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }